/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementNavIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ElementNavIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path d="M13 12H3V11H13V12Z" fill="currentColor" />
              <path d="M13 8H3V7H13V8Z" fill="currentColor" />
              <path d="M13 4H3V3H13V4Z" fill="currentColor" />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ElementNavIcon.tags = [
  'nav',
  'menu',
  'navigation',
  'hamburger',
  'list',
  'options',
  'bars',
  'lines',
];

ElementNavIcon.category = 'Navigator';

ElementNavIcon.iconSize = 16;
